export enum IdentityVerificationManualUploadState {
  COMPLETED = "completed",
  ERROR = "error",
  NOT_COMPLETED = "not_completed",
}
